import FeedbackSuccess from '../../../components/atoms/feedbacks/feedback-success.vue'
import PageHeadline from '../../../components/molecules/headlines/PageHeadline.vue'

export default {
  components: { FeedbackSuccess, PageHeadline },
  data() {
    return {
      showableFeedback: false,
      message: ''
    }
  },
  mounted() {
    const profileFeedbackMessage = document.querySelector('#flash_message')
      .value

    if (profileFeedbackMessage) {
      this.showFeedback(profileFeedbackMessage)
    }
  },
  methods: {
    enterFeedback() {
      setTimeout(() => {
        this.showableFeedback = false
      }, 3000)
    },
    showFeedback(message) {
      this.showableFeedback = true
      this.message = message
    }
  }
}
